import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CONFIG from "../utils/config";
import "../styles/motorv2.css"; // Your custom CSS for this component

const Motorv2 = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { id } = location.state || {};
  const [policies, setPolicies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPolicyData = async () => {
      if (!id || id.length === 0) {
        toast.error("Missing policy IDs. Redirecting to home.");
        navigate("/");
        setLoading(false);
        return;
      }

      setLoading(true);

      try {
        const responses = await Promise.all(
          id.map((policyId) =>
            fetch(`${CONFIG.BASE}/insurance/getVehicleData`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: policyId }),
            }).then((res) => {
              if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
              }
              return res.json();
            })
          )
        );

        setPolicies(responses);
      } catch (error) {
        console.error("❌ Error fetching policy data:", error);
        toast.error("Unable to load policy details.");
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    fetchPolicyData();
  }, [id, navigate]);

  // 👇 Handler for action button
  const handleNavigateToMotor = (id) => {
    navigate("/motor", { state: { id: id } });
    console.log("✅ Selected Policy ID:", id);  // log only the clicked one
  };
  

  return (
    <div className="policy-page-container">
      <div className="policy-card-wrapper">
        <h3 className="policy-page-title">Policy Records</h3>

        {loading ? (
          <div className="policy-loading-state">
            <div className="policy-spinner"></div>
            <p>Loading policies...</p>
          </div>
        ) : policies.length > 0 ? (
          <div className="policy-table-responsive">
            <table className="policy-details-table">
              <thead>
                <tr>
                  <th>Policy No.</th>
                  <th>Insured Name</th>
                  <th>Vehicle Reg No.</th>
                  <th>Chassis No.</th>
                  <th>Make</th>
                  <th>Model</th>
                  <th>Usage</th>
                  <th>Year</th>
                  <th>Seats</th>
                  <th>Cylinder</th>
                  <th>Expiry Date</th>
                  <th>Coverage</th>
                  <th>Action</th> {/* New Column */}
                </tr>
              </thead>
              <tbody>
                {policies.map((policy) => (
                  <tr key={policy.id}>
                    <td>{policy.policyNumber || "-"}</td>
                    <td>{policy.insuredName || "-"}</td>
                    <td>{policy.vehicleRegistrationNumber || "-"}</td>
                    <td>{policy.chassisNumber || "-"}</td>
                    <td>{policy.vehMake || "-"}</td>
                    <td>{policy.vehModel || "-"}</td>
                    <td>{policy.vehUsage || "-"}</td>
                    <td>{policy.manufacturingYear || "-"}</td>
                    <td>{policy.vehSeat || "-"}</td>
                    <td>{policy.vehCylinder || "-"}</td>
                   
                    <td>
                      {policy.policyExpiryDate
                        ? new Date(policy.policyExpiryDate).toLocaleDateString()
                        : "-"}
                    </td>
                    <td>{policy.policyCovers || "-"}</td>
                    <td>
                      <button
                        className="policy-primary-button"
                        onClick={() => handleNavigateToMotor(policy.id)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="policy-empty-state">
            <svg
              className="policy-empty-state-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2H7a2 2 0 00-2 2v2m14 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 11H5"
              ></path>
            </svg>
            <p>No policies found for the provided IDs.</p>
            <button
              className="policy-primary-button"
              onClick={() => navigate("/")}
            >
              Go to Home
            </button>
          </div>
        )}

        <div className="policy-button-group">
          <button
            className="policy-secondary-button"
            onClick={() => navigate("/")}
          >
            <svg
              className="policy-button-icon"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              ></path>
            </svg>
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default Motorv2;
